export default (api) => {
    return {
        studentStats: (school_id, options) => api.get(`statistics/schools/${school_id}/students`, options),
        challengesStats: options => api.get(`statistics/challenge_versions`, options),
        challengeStats: (challenge_id, options) => api.get(`statistics/challenge_versions/${challenge_id}`, options),
        lessonsAvgTimeSpent: (user_id, options) => api.get(`statistics/lessons/times/${user_id}`, options),
        timeSpent: options => api.get('statistics/streams/times', options),
        appStats: options => api.get('statistics/app', options),
        impact: options => api.get('statistics/impact', options)
    }
}
